import CommonMixin from "@/common/mixins/common-mixin";
export default {
    mixins: [CommonMixin],
    data() {
        return {
            model:null,
            single: {},
            header: [],
            fields: {},
            edit_mode: false,
            view_mode: false,
            page: {
                total: 0,
                display: 1,
                current: 0,
                count: 0,
                size: 20
            },
            search: {
                search: '',
                filters: [],
                page_size:-1,
                page: 1,
                sort: {},
                date_range:[
                    ((new Date()).Format('yyyy-MM-dd hh:mm'))
                    , ((new Date((new Date().getTime() + 3600 * 1000 * 24 * 365)).Format('yyyy-MM-dd 23:59')))],
                use_date_range:0,
            },
            old: null,
            old_filters:null,
            old_date:null,
            records: [],
            is_first:true,
        }
    },
    computed:{
        canAdd(){
            let can = true;
            const level = parseInt(this.user.role_level);
            if (this.preset.app && this.preset.app.create_meeting_forbidden) {
                if (level < 3) {
                    can = false;
                }
            }
            return can;
        }
    },
    methods: {
        reload() {
            let vm = this;
            let obj = Object.assign({},this.search);
            delete obj.page;
            const diff = JSON.stringify(obj);
            if (this.old !== diff) {
                this.search.page = 1;
                this.old = diff;
            }
            this.$api(this.model+'.List', this.search, true).then(response => {
                if (response.data.data) {
                    vm.records = response.data.data.data;
                    vm.page = Object.assign(vm.page, response.data.data.page);
                    if (vm.is_first) {
                        vm.header = response.data.data.header;
                        obj.page_size = vm.page.size;
                        this.old = JSON.stringify(obj);
                    }
                    vm.setPageSize(vm.page.size);
                    vm.is_first = false;
                }
            });
        },
        handleSuccess(){
            this.edit_mode = false;
            this.reload();
        },
        handleCancel(){
            this.edit_mode = false;
        },
        handleEdit(id) {
            let vm=this;
            this.$api(vm.model+'.Get', {id: id}, true).then(response => {
                vm.single = response.data.data.data || {};
                vm.fields = response.data.data.fields;
                vm.edit_mode = true;
                Object.keys(vm.fields).forEach(function (key) {
                    let x = vm.fields[key];
                    if (x.type === 'picture' && !vm.single[key]) {
                        vm.single[key] = [];
                    }
                });
            });
        },
        handleCopy(id) {
            let vm=this;
            this.$api(vm.model+'.Get', {id: id}, true).then(response => {
                vm.single = response.data.data.data || {};
                vm.single.id = 0;
                vm.fields = response.data.data.fields;
                vm.edit_mode = true;
                vm.fields.forEach(x => { if (x.type === 'picture' && !vm.single[x]) {vm.single[x] = []}});
            });
        },
        handleReload(data) {
            this.search = data;
            this.reload();
        },
        handleReview(id) {
            let vm = this;
            vm.view_mode = 0;
            this.$api(this.model + '.Get', {id: id, review: true}, true).then(res => {
                vm.single = res.data.data;
                vm.view_mode = 1;
            });
        },
        handleCalendarChange(data) {
            this.search.date_range = data;
            this.reload();
        }
    },
    mounted() {
        if (this.search.page_size === -1) {
            if (this.$isMobile())
                this.search.page_size = 10;
            else
                this.search.page_size = this.pageSize;
        }
        this.reload();
    },
}
